import { useOneSignal } from '@onesignal/onesignal-vue3'

// OneSignal is only initialised when an app ID is configured, so without one the
// SDK's deferred queue is never flushed and these calls would hang unresolved
const oneSignalEnabled = () => Boolean(import.meta.env.VITE_ONESIGNAL_APP_ID)

export default function usePushNotificationUser() {
  // Attaches this device's push subscription to the logged in user, so the API can
  // target notifications by external ID rather than only by segment. An existing
  // anonymous subscription is transferred to the user rather than duplicated, so
  // users who subscribed before this was added are linked on their next visit
  const identifyPushUser = (userId: number) => {
    if (!oneSignalEnabled()) return

    useOneSignal()
      .login(String(userId))
      .catch((error) => console.error('OneSignal login failed:', error))
  }

  // Reverts the device to an anonymous subscription. Portal accounts are shared
  // across engineers' devices, so the next user mustn't inherit these notifications
  const forgetPushUser = () => {
    if (!oneSignalEnabled()) return

    useOneSignal()
      .logout()
      .catch((error) => console.error('OneSignal logout failed:', error))
  }

  return {
    identifyPushUser,
    forgetPushUser
  }
}
